import BSN from "bootstrap.native";
import { storefrontMenuTemplate } from "../../helpers/storefrontTheme";

// Height the category nav adds to the sticky header stack. In the Sidebar template the nav is a
// rail beside the items, so it adds none
const categoryNavHeight = (element: any) =>
  storefrontMenuTemplate() === "sidebar" ? 0 : element?.clientHeight || 0;

const handleCategoryScrollSpy = (categoryScrollSpyObj: any) => {
  delete categoryScrollSpyObj.scrollSpyHandler;
  if (!categoryScrollSpyObj.scrollSpyHandler) {
    var categoryScrollSpyElement = document.getElementsByClassName('category-items')[0];
    if (categoryScrollSpyElement) {
      var categoryScrollTarget = document.getElementById('cat-navigation');
      var topHeaderSection = document.getElementById("top-header");
      var topHeaderSectionHeight = topHeaderSection ? topHeaderSection.clientHeight : 0;
      var catSection = document.getElementById("horizontal-category");
      var catSectionHeight = categoryNavHeight(catSection);

      // To ensure the category header updates before the main heading reaches the top while scrolling,
      // we add an additional offset to the total offset calculation.
      var additionalOffset = 200;
      var offset = topHeaderSectionHeight + catSectionHeight + additionalOffset;
      categoryScrollSpyObj.scrollSpyHandler = new BSN.ScrollSpy(
        categoryScrollSpyElement,
        {
          target : categoryScrollTarget,
          offset: offset
        }
      );

      categoryScrollSpyElement.addEventListener('activate.bs.scrollspy', function() {
        if (window.document.getElementsByClassName("category-entry-name active").length > 0) {
          var activeEntry: any = window.document.getElementsByClassName("category-entry-name active")[0];
          // The Sidebar rail scrolls vertically to keep the active category in view
          window.document.getElementById("horizontal-category")?.scrollTo(
            storefrontMenuTemplate() === "sidebar"
              ? { top: Math.max(activeEntry.offsetTop - 48, 0), left: 0 }
              : { top: 0, left: activeEntry.offsetLeft - 14 }
          );
        }
      }, false);
    }
  }
  return categoryScrollSpyObj;
}

export {
  handleCategoryScrollSpy,
  categoryNavHeight,
}
